// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsCustomPrefundCalcPropertyDto
 */
export interface IIsCustomPrefundCalcPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsCustomPrefundCalcPropertyDto
     */
    is_custom_prefund_calc?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsCustomPrefundCalcPropertyDto
     */
    is_custom_prefund_calc_state?: IIsCustomPrefundCalcPropertyDtoIsCustomPrefundCalcStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsCustomPrefundCalcPropertyDtoIsCustomPrefundCalcStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsCustomPrefundCalcPropertyDto interface.
 */
export function instanceOfIIsCustomPrefundCalcPropertyDto(value: object): value is IIsCustomPrefundCalcPropertyDto {
    return true;
}

export function IIsCustomPrefundCalcPropertyDtoFromJSON(json: any): IIsCustomPrefundCalcPropertyDto {
    return IIsCustomPrefundCalcPropertyDtoFromJSONTyped(json, false);
}

export function IIsCustomPrefundCalcPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsCustomPrefundCalcPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_custom_prefund_calc': json['is_custom_prefund_calc'] == null ? undefined : json['is_custom_prefund_calc'],
        'is_custom_prefund_calc_state': json['is_custom_prefund_calc_state'] == null ? undefined : json['is_custom_prefund_calc_state'],
    };
}

export function IIsCustomPrefundCalcPropertyDtoToJSON(json: any): IIsCustomPrefundCalcPropertyDto {
    return IIsCustomPrefundCalcPropertyDtoToJSONTyped(json, false);
}

export function IIsCustomPrefundCalcPropertyDtoToJSONTyped(value?: IIsCustomPrefundCalcPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_custom_prefund_calc': value['is_custom_prefund_calc'],
        'is_custom_prefund_calc_state': value['is_custom_prefund_calc_state'],
    };
}

